import { render, staticRenderFns } from "./modal_unit_data.vue?vue&type=template&id=57adc660&scoped=true"
import script from "./modal_unit_data.vue?vue&type=script&lang=js"
export * from "./modal_unit_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57adc660",
  null
  
)

export default component.exports